// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo_logoContainer__3UfZS","img":"Logo_img__1Q0s8"};